export default __webpack_public_path__ + "011503d6abe36a3c28c30214ad9c3ec2.png";